export const INSTRUMENT_OPTIONS = [
	{ label: "Гитара", value: "guitar" },
	{ label: "Флейта", value: "flute" },
	{ label: "Фортепиано", value: "piano" },
	{ label: "Ударные", value: "drum" },
	{ label: "Вокал", value: "vocal" },
	{ label: "Скрипка", value: "violin" },
	// Не показывается на шаге выбора (только 6 основных инструментов),
	// оставлено для совместимости со старыми сохранёнными предпочтениями
	{ label: "Другое", value: "other" },
];

export const LEVEL_OPTIONS_BY_INSTRUMENT = {
	Гитара: [
		{ label: "Никогда не играл(а)", value: "from_scratch" },
		{ label: "Знаю пару аккордов", value: "beginner" },
		{ label: "Играю простые песни", value: "basic_songs" },
		{ label: "Уверенно играю", value: "experienced" },
	],
	Флейта: [
		{ label: "Никогда не играл(а)", value: "from_scratch" },
		{ label: "Знаю основы дыхания и постановки", value: "beginner" },
		{ label: "Играю простые мелодии", value: "basic_melodies" },
		{ label: "Уверенно играю", value: "experienced" },
	],
	Фортепиано: [
		{ label: "Никогда не играл(а)", value: "from_scratch" },
		{ label: "Знаю ноты и простые упражнения", value: "beginner" },
		{ label: "Играю простые произведения", value: "basic_pieces" },
		{ label: "Уверенно играю", value: "experienced" },
	],
	Ударные: [
		{ label: "Никогда не играл(а)", value: "from_scratch" },
		{ label: "Знаю базовые ритмы", value: "beginner" },
		{ label: "Играю простые грувы", value: "basic_grooves" },
		{ label: "Уверенно играю", value: "experienced" },
	],
	Вокал: [
		{ label: "Никогда не занимался(ась)", value: "from_scratch" },
		{ label: "Иногда пою для себя", value: "beginner" },
		{ label: "Выступал(а) или занимался(ась)", value: "basic_performance" },
		{ label: "Уверенно пою", value: "experienced" },
	],
	Скрипка: [
		{ label: "Никогда не играл(а)", value: "from_scratch" },
		{ label: "Знаю основы постановки рук", value: "beginner" },
		{ label: "Играю простые мелодии", value: "basic_melodies" },
		{ label: "Уверенно играю", value: "experienced" },
	],
	Другое: [
		{ label: "С нуля", value: "from_scratch" },
		{ label: "Есть немного опыта", value: "beginner" },
		{ label: "Продолжающий уровень", value: "intermediate" },
		{ label: "Продвинутый уровень", value: "experienced" },
	],
};

export const START_DAY_OPTIONS = [
	{ label: "по выходным", value: "weekends" },
	{ label: "в будни", value: "weekdays" },
];

export const START_TIME_OPTIONS = [
	{ label: "утром", value: "morning" },
	{ label: "днем", value: "day" },
	{ label: "вечером", value: "evening" },
];

const DAY_UI_TO_STORAGE_MAP = {
	weekends: 'weekend',
	weekdays: 'weekday',
};

const DAY_STORAGE_TO_UI_MAP = {
	weekend: 'weekends',
	weekday: 'weekdays',
};

const VALID_DAY_STORAGE_VALUES = Object.values(DAY_UI_TO_STORAGE_MAP);
const VALID_TIME_VALUES = START_TIME_OPTIONS.map((o) => o.value);

export const STUDENT_ONBOARDING_PREFERENCE_KEYS = {
	instrument: 'instrument',
	instrumentId: 'instrument_id',
	level: 'level',
	daysType: 'days_type',
	timeOfDay: 'time_of_day',
};

export const getInstrumentOptionByValue = (value) => (
	INSTRUMENT_OPTIONS.find((option) => option.value === value) || null
);

export const getInstrumentOptionByLabel = (label) => (
	INSTRUMENT_OPTIONS.find((option) => option.label === label) || null
);

export const getLevelOptionsByInstrumentValue = (instrumentValue) => {
	const instrumentOption = getInstrumentOptionByValue(instrumentValue);

	return LEVEL_OPTIONS_BY_INSTRUMENT[instrumentOption?.label] || [];
};

export const getStartWhenValue = ({ days = [], times = [] }) => {
	if (!days.length || !times.length) return null;
	return {
		days_type: days.map((day) => DAY_UI_TO_STORAGE_MAP[day] || day).filter(Boolean),
		time_of_day: times,
	};
};

export const parseStartWhenValue = (value = '') => {
	if (value && typeof value === 'object' && !Array.isArray(value)) {
		const days = (value.days_type || [])
			.map((day) => DAY_STORAGE_TO_UI_MAP[day] || day)
			.filter((day) => START_DAY_OPTIONS.some((option) => option.value === day));
		const times = (value.time_of_day || [])
			.filter((time) => START_TIME_OPTIONS.some((option) => option.value === time));
		const pairs = days.flatMap((day) => times.map((time) => ({ day, time })));
		return { days, times, pairs };
	}

	if (!value) return { days: [], times: [], pairs: [] };

	const items = Array.isArray(value) ? value : String(value).split(',');
	const days = [];
	const times = [];
	const pairs = [];

	items.forEach((item) => {
		const [day, time] = String(item).trim().split('_');
		const isValidDay = START_DAY_OPTIONS.some((option) => option.value === day);
		const isValidTime = START_TIME_OPTIONS.some((option) => option.value === time);

		if (isValidDay && isValidTime) {
			if (!days.includes(day)) days.push(day);
			if (!times.includes(time)) times.push(time);
			pairs.push({ day, time });
		}
	});

	return { days, times, pairs };
};

export const isValidInstrumentValue = (value) => (
	INSTRUMENT_OPTIONS.some((option) => option.value === value)
);

export const isValidLevelValue = ({ instrument, level }) => (
	getLevelOptionsByInstrumentValue(instrument).some((option) => option.value === level)
);

export const isValidStartWhenValue = (value) => {
	if (value && typeof value === 'object' && !Array.isArray(value)) {
		const days = value.days_type || [];
		const times = value.time_of_day || [];
		return (
			Array.isArray(days) &&
			Array.isArray(times) &&
			days.length > 0 &&
			times.length > 0 &&
			days.every((day) => VALID_DAY_STORAGE_VALUES.includes(day)) &&
			times.every((time) => VALID_TIME_VALUES.includes(time))
		);
	}

	const { pairs } = parseStartWhenValue(value);
	return pairs.length > 0;
};

const normalizeText = (value = '') => (
	String(value)
		.toLowerCase()
		.replace(/[^\p{L}\p{N}]+/gu, '')
);

export const getAvailableInstrumentItems = (instrumentGroups = []) => (
	instrumentGroups.flatMap((group) => group?.instruments || [])
);

export const resolveAvailableInstrumentByValue = (instrumentGroups = [], value) => {
	if (!value) return null;

	const availableInstruments = getAvailableInstrumentItems(instrumentGroups);
	const instrumentOption = getInstrumentOptionByValue(value);
	const normalizedLabel = normalizeText(instrumentOption?.label || value);

	return availableInstruments.find((instrument) => (
		instrument?.id === value ||
		normalizeText(instrument?.name) === normalizedLabel ||
		normalizeText(instrument?.name).includes(normalizedLabel)
	)) || null;
};

export const resolveInstrumentValueByProfileInstrument = (instrument) => {
	const normalizedName = normalizeText(instrument?.name);

	if (!normalizedName) return null;

	return INSTRUMENT_OPTIONS.find((option) => (
		normalizedName === normalizeText(option.label) ||
		normalizedName.includes(normalizeText(option.label))
	))?.value || 'other';
};

export const resolveInstrumentValueByAvailableInstrument = (instrument) => (
	resolveInstrumentValueByProfileInstrument(instrument)
);

// На шаге выбора инструмента показываем только 6 основных инструментов
// (порядок — как в массиве)
export const ONBOARDING_INSTRUMENT_WHITELIST = ['гитара', 'вокал', 'фортепиано', 'флейта', 'скрипка', 'ударные'];

export const isOnboardingInstrumentAllowed = (name) => (
	ONBOARDING_INSTRUMENT_WHITELIST.includes(normalizeText(name))
);

const sortByWhitelistOrder = (a, b) => (
	ONBOARDING_INSTRUMENT_WHITELIST.indexOf(normalizeText(a?.name)) -
	ONBOARDING_INSTRUMENT_WHITELIST.indexOf(normalizeText(b?.name))
);

export const filterOnboardingInstruments = (instrumentGroups = []) => {
	// Группы из API могли быть разбиты по категориям — для строгого порядка
	// объединяем всё в одну группу (UI группировку не использует)
	const filtered = getAvailableInstrumentItems(instrumentGroups)
		.filter((instrument) => isOnboardingInstrumentAllowed(instrument?.name))
		.sort(sortByWhitelistOrder);

	return filtered.length ? [{ instruments: filtered }] : [];
};
